import React from 'react';
import { AudioLines } from 'lucide-react';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from '../ui/select';
import { useVoicePopupRef } from './useVoicePopupRef';

export const VoiceModelSelect = ({ value, onChange, catalog, isDarkMode }) => {
  const popupRef = useVoicePopupRef();
  const models = [
    { id: 'eleven_v4', name: 'Eleven v4', detail: 'Expressive, quality-first', badge: 'NEW' },
    { id: 'eleven_v4_turbo', name: 'Eleven v4 Turbo', detail: 'Low-latency, real-time conversations', badge: 'NEW' },
    { id: 'eleven_v3', name: 'Eleven v3', detail: 'Conversational · expressive delivery' },
    { id: 'eleven_flash_v2_5', name: 'Flash v2.5', detail: 'Fast, familiar delivery' },
  ];
  const selected = models.find(m => m.id === value);
  return <div data-testid="voice-model-field">
    <label id="voice-model-label" className={`block text-sm mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Voice model</label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid="voice-model-select" aria-labelledby="voice-model-label" className={`h-11 gap-2 rounded-lg ${isDarkMode ? 'bg-white/[0.03] border-white/10 text-white' : 'bg-white border-gray-200 text-gray-900'}`}>
        <span className="flex items-center gap-2 min-w-0"><AudioLines size={16} className="shrink-0 text-teal-500" /><SelectValue>{selected?.name || value}</SelectValue></span>
      </SelectTrigger>
      <SelectContent ref={popupRef} data-testid="voice-model-options" position="popper" side="bottom" align="start" sideOffset={5}
        className={`z-[90] w-[var(--radix-select-trigger-width)] max-h-80 rounded-lg ${isDarkMode ? 'bg-[#101117] border-white/10 text-gray-100' : 'bg-white border-gray-200 text-gray-900'}`}>
        {!selected && value && <SelectItem value={value} data-testid="voice-model-existing">{value}</SelectItem>}
        {models.map(model => <SelectItem key={model.id} value={model.id} data-testid={`voice-model-${model.id}`}
          disabled={model.id.startsWith('eleven_v4') && !catalog}
          className={`py-2.5 cursor-pointer ${isDarkMode ? 'focus:bg-white/5 focus:text-white' : 'focus:bg-gray-100 focus:text-gray-900'}`}>
          <span className="flex items-center gap-2 text-sm font-medium">{model.name}{model.badge && <span className={`text-[9px] font-semibold ${isDarkMode ? 'text-teal-400' : 'text-teal-700'}`}>{model.badge}</span>}</span>
          <span className={`block mt-0.5 text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{model.detail}</span>
        </SelectItem>)}
      </SelectContent>
    </Select>
  </div>;
};